module.exports = __webpack_public_path__ + "assets/images/ote_sport_6.eb4399a00409eead02d59e1845a7d483.png";